<dx-report-designer [reportUrl]="ReportName()" height="700px"  #Editor >
  <dxrd-request-options [getDesignerModelAction]="getDesignerModelAction()" [host]="Host()"></dxrd-request-options>
  <dxrd-designer-model-settings [allowMDI]="true">
    <dxrd-wizard-settings [useFullscreenWizard]="false" [enableSqlDataSource]="false"></dxrd-wizard-settings>
  </dxrd-designer-model-settings>
  <dxrd-callbacks (CustomizeMenuActions)="CustomizeMenuActions($event)" (CustomizeElements)="CustomizeElements($event)" )>

  </dxrd-callbacks>
</dx-report-designer>
